import axios from 'axios'
import { AxiosApi } from './axiosApi'
import { configureBasicXLegacyTokenAPI } from '../configuration/basicXLegacyToken'

export class BasicXLegacyTokenAPI extends AxiosApi {
  constructor({ domain }: { domain: string }) {
    super(configureBasicXLegacyTokenAPI(domain))
  }
}

export class BasicXLegacyTokenHttpRequest extends AxiosApi {
  constructor() {
    super(axios)
  }
}
